module.exports = __webpack_public_path__ + "img/shart-2.204efdec.png";